import App from './App.svelte';

const app = new App({
	target: document.body
});

// Turning debug mode off below
//console.log = function() {}

export default app;